import { render, staticRenderFns } from "./auditUserModal.vue?vue&type=template&id=4891ef9e&"
import script from "./auditUserModal.vue?vue&type=script&lang=js&"
export * from "./auditUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports